import React from "react";
import { ClockCounterClockwise } from "@phosphor-icons/react";

const CReport = ({ cb }) => {
  const {
    id,
    username,
    type,
    report,
    created_at,
    updated_at,
    status,
  } = cb;

  return (
    <div>
      <div className="p-2.5 relative rounded-lg rounded-se-none shadow flex flex-col gap-2 bg-slate-50">
        <div className="flex border-b border-gray-400 justify-start">
          <p className="text-md  font-semibold">{type}</p>
        </div>
        <div className="flex gap-2">
            {/* KOTAK ID */}
          <div className="flex flex-col  gap-2">
            <div
              className={`
                bg-red-600 text-amber-100 px-5
                mt-1.5 flex flex-col rounded-lg gap-3`}
            >
              <p
                className={
                  "text-2xl h-full py-2 justify-center items-center flex flex-col font-bold "
                }
              >
                {id}
              </p>
            </div>
          </div>

          {/* BUILD TIME STATUS */}
          <div className="pt-1.5 px-1 flex justify-between gap-4 flex-col w-full">
            <div className="flex flex-col gap-4 justify-center w-full items-center">
              <div className="flex-1 px-4 py-3  bg-slate-300 rounded-lg text-slate-500 w-full gap-2  flex justify-between items-center">
                <p className=" whitespace-nowrap font-light  text-center text-xs">
                  {getIndochinaDate(created_at)}
                </p>
                <p className="tracking-widest text-lg font-semibold text-center">
                  {getIndochinaTime(created_at)}
                </p>
              </div>
              <p
                className={`w-full min-h-6 p-2 
                bg-red-200 text-red-600
                text-xs rounded-lg`}
              >
                {report || "-"}
              </p>
            </div>

            <div className="flex gap-1.5 justify-center px-2 items-center">
              <ClockCounterClockwise />
              <p className="font-semibold whitespace-nowrap text-xs">
                {username}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CReport;

function getIndochinaTime(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    minute: "2-digit",
  }); // Format HH:mm
}
function getIndochinaDate(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    day: "numeric",
    month: "long",
    year: "numeric",
  }); // Format HH:mm
}
